export default __webpack_public_path__ + "static/media/4t.f1dce41a.jpg";